import { REDUX_STORE } from '@funnels/constants';
import {
  BrokerInterviewsGuarantorWithId,
  ClearBrokerInterviewsGuarantorErrorAction,
  DeleteBrokerInterviewsGuarantorAction,
  DeleteBrokerInterviewsGuarantorFailAction,
  DeleteBrokerInterviewsGuarantorSuccessAction,
  FetchAllBrokerInterviewsGuarantorAction,
  FetchAllBrokerInterviewsGuarantorFailAction,
  FetchAllBrokerInterviewsGuarantorSuccessAction,
  FetchBrokerInterviewsGuarantorAction,
  FetchBrokerInterviewsGuarantorFailAction,
  FetchBrokerInterviewsGuarantorSuccessAction,
  UpsertBrokerInterviewsGuarantorAction,
  UpsertBrokerInterviewsGuarantorFailAction,
  UpsertBrokerInterviewsGuarantorSuccessAction,
} from '@funnels/types';

export function clearBrokerInterviewsGuarantorError(): ClearBrokerInterviewsGuarantorErrorAction {
  return { type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.CLEAR_BROKER_INTERVIEWS_GUARANTOR_ERROR };
}

export function deleteBrokerInterviewsGuarantor(
  applicationId: string,
  applicantId: string
): DeleteBrokerInterviewsGuarantorAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.DELETE_BROKER_INTERVIEWS_GUARANTOR,
    applicationId,
    applicantId,
  };
}

export function deleteBrokerInterviewsGuarantorFail(
  applicantId: string,
  message: string = 'Unknown error'
): DeleteBrokerInterviewsGuarantorFailAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.DELETE_BROKER_INTERVIEWS_GUARANTOR_FAIL,
    applicantId,
    message,
  };
}

export function deleteBrokerInterviewsGuarantorSuccess(
  applicantId: string
): DeleteBrokerInterviewsGuarantorSuccessAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.DELETE_BROKER_INTERVIEWS_GUARANTOR_SUCCESS,
    applicantId,
  };
}

export function fetchBrokerInterviewsGuarantor(
  applicationId: string,
  applicantId: string
): FetchBrokerInterviewsGuarantorAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_BROKER_INTERVIEWS_GUARANTOR,
    applicationId,
    applicantId,
  };
}

export function fetchBrokerInterviewsGuarantorFail(
  applicantId: string,
  message: string = 'Unknown error'
): FetchBrokerInterviewsGuarantorFailAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_BROKER_INTERVIEWS_GUARANTOR_FAIL,
    applicantId,
    message,
  };
}

export function fetchBrokerInterviewsGuarantorSuccess(
  brokerInterviewsGuarantor: BrokerInterviewsGuarantorWithId
): FetchBrokerInterviewsGuarantorSuccessAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_BROKER_INTERVIEWS_GUARANTOR_SUCCESS,
    brokerInterviewsGuarantor,
  };
}

export function fetchAllBrokerInterviewsGuarantor(applicationId: string): FetchAllBrokerInterviewsGuarantorAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_ALL_BROKER_INTERVIEWS_GUARANTOR,
    applicationId,
  };
}

export function fetchAllBrokerInterviewsGuarantorFail(
  applicationId: string,
  message: string = 'Unknown error'
): FetchAllBrokerInterviewsGuarantorFailAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_ALL_BROKER_INTERVIEWS_GUARANTOR_FAIL,
    applicationId,
    message,
  };
}

export function fetchAllBrokerInterviewsGuarantorSuccess(
  brokerInterviewsGuarantorList: BrokerInterviewsGuarantorWithId[]
): FetchAllBrokerInterviewsGuarantorSuccessAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_ALL_BROKER_INTERVIEWS_GUARANTOR_SUCCESS,
    brokerInterviewsGuarantorList,
  };
}

export function upsertBrokerInterviewsGuarantor(
  applicationId: string,
  brokerInterviewsGuarantorList: BrokerInterviewsGuarantorWithId[]
): UpsertBrokerInterviewsGuarantorAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS_GUARANTOR,
    applicationId,
    brokerInterviewsGuarantorList,
  };
}

export function upsertBrokerInterviewsGuarantorFail(
  applicationId: string,
  message: string = 'Unknown error'
): UpsertBrokerInterviewsGuarantorFailAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS_GUARANTOR_FAIL,
    applicationId,
    message,
  };
}

export function upsertBrokerInterviewsGuarantorSuccess(
  brokerInterviewsGuarantorList: BrokerInterviewsGuarantorWithId[]
): UpsertBrokerInterviewsGuarantorSuccessAction {
  return {
    type: REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS_GUARANTOR_SUCCESS,
    brokerInterviewsGuarantorList,
  };
}
